import { takeLatest, put } from 'redux-saga/effects';
import { createAxiosGameCDK, logNative, createAxios } from '../utils/utils';
import { GAMECDK_CREATE_QRCODE_9011, GAMECDK_POLL_9011, GAMECDK_GET_DESC_9011 } from '../config';
import {
  GAMECDK_CREATE_QRCODE,
  GAMECDK_CREATE_QRCODE_SUCCESS,
  GAMECDK_POLLS,
  GAMECDK_POLL_SUCCESS,
  GAMECDK_CODE_GET_DESC,
  GAMECDK_CODE_GET_DESC_SUCCESS,
} from '../constants/gamecdk';
import jsrsasign from 'jsrsasign';

function generateRandomString(num = 32) {
  const str = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
  const strLength = str.length;
  let result = '';
  for (let i = 0; i < num; i++) {
    result += str[Math.floor(Math.random() * strLength)];
  }

  return result;
}

function serialization(data = {}) {
  return Object.keys(data)
    .sort()
    .filter(k => {
      if (
        data[k] === undefined ||
        data[k] === null ||
        data[k] === '' ||
        Number.isNaN(data[k]) ||
        Object.prototype.toString.call(data[k]) === '[object Object]' ||
        Object.prototype.toString.call(data[k]) === '[object Array]' ||
        Object.prototype.toString.call(data[k]) === '[object File]' ||
        Object.prototype.toString.call(data[k]) === '[object Blob]'
      ) {
        return false;
      }

      return true;
    })
    .map(k => `${k}=${data[k]}`)
    .join('&');
}

// 获取签名
function getSHA256withRSA(params) {
  let privateKeyStr = `
  -----BEGIN PRIVATE KEY-----
  MIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDcsRi561VosBeHrrp5UdOHL842lZrHFW3qM5aO5SjDmqv+eYleqoA5lS1HaY1cwGd5fqmpsjyUOnuG5MIuCKGY+5y92xlsp/6m1HdC0psWwtQdk+BKHZBrzGqCETIBabdEXEvsxdCSHOvcy+qUkIjGBoQgaF3cQ3OYAxnqhJ2OSspnDv17VRCZmV2tVlCVg3hwPbkCgTzFmAUvWNlXq8i4uTo6sero0T/1yoxOiR7xArKVAy6uIWHPB4sbdVo9HbJMsws7YGRjlnOUly5utciC1e4uJKmqt9Z2IOfgU15Yj+xuVePkR2R2E8f9MZ8QR/N/38loOXJ9/knJO7iBgZBRAgMBAAECggEBAI2kJCh/P+vWyONOY2Ql/ksPhZxG3HXV7RuZTJIdxdH03VqQCnh1maJbehoRRqc23bJ+dsnxGSxRdKKZA3+kDoMvSeQYUPMJx0ivqHN81AkBtj3dgOBQpTZqlhkwjBWYEgWP7zLhqwF8Cm1FeyMquH3QBND/6u3JZNE1fFamErEVYio0mNS+ETE4t26xJkxVI5LgSCIRCEEJNPiCdsuSc/O6wwwvHWRuhAQ34HsN9WO8z1r1KlMgfs4DXpzviva7zZmhAE2oAB37gTOZBNZC9bAMm/qBSLQzS02E6V9YosHaxBHZMNexEo4y2kt+OPemDLUiRbO3fWtcwSNLehf+VAECgYEA87nlp6ECE50vpfde9+Z1kiEinyyzbi7l0Q4jtYMshdUUPDCpmDbOtMS8cZAcgo7Ipcj1ZAb0FbsHbrmyXFzMFjZxf99x4IQ5Yc2+Oo3o4wDxahxzwM1e8OE4D0pKH0KB3qCCV75IYs4OPNgDDbTZjm/LKcMzYNHQ0BHlXxeMYCECgYEA58494FGxycGYkMyEsAM0zbVRvLafgDWfpxauimU4eyZCoj2VA/RD9L9EY7yYgJJFOtjbLsUnIEpfu/lIu02ZUOBgeaHGlBk75GQUEmYjpnjVoPW5HmPqEbO6oj8WfU8cP13hW+pjS1QrOgNspRCysUrCHP9GjVPwJbagp2sl6jECgYAWBQiToX9PiFcCtpu05/RdVHMNUHuRi9kljxJ41rYSDVM7sOXRo7n/KPshg3Sf8wh7ufE5rUsmH3Snc02C/LtPknGkrOpb73ZDuNPj9GhDAhXNkW5/z84xExf+gaa6tkaHd5bvGHjvvFAa/SUheuJg9Qa06jbdG3ezJLrFYZpEIQKBgF9h/xYJp6WEUtnqPgMLHrQykvKbFuCzsAEaFTH/WpFZ+fs2adXZsgjIl0SO+xWUmoYPa4lAOMxRrjjz55ii4p5j5W7HQaX5CCr/fz7e5nZ+rDDyS30U0eD82qQeX4uqfM4aPDwNI1SAytSxSghV6aGISH2UERzgWCW8kziwn0ZRAoGARUCA8peP2wu4Ke9W6PWuhlbPL/aN/anpTte4iVyOHHfxGk7TyPT+tGvvzWsirV0WzYjuGdxcd+walmNom+adcUaBD6seoD9GOohtEtY6464KdPApDU7CwAKYA2uXU+XnsBQE6N8lUGRowDpFKI+ZkTdjOgKK5Y+naLl5p1Kd+kQ=
  -----END PRIVATE KEY-----
  `;
  let paramObj = {
    ...params,
  };
  const paramStr = serialization(paramObj);
  const signature = new jsrsasign.KJUR.crypto.Signature({ alg: 'SHA256withRSA' });
  const prvKey = jsrsasign.KEYUTIL.getKey(privateKeyStr);
  signature.init(prvKey);
  signature.updateString(paramStr);
  let sign = jsrsasign.hextob64(signature.sign());
  return sign;
}

function* fetchGameCdkQRcode(data) {
  try {
    // 先改一下状态 loading: 1:请求中  2:请求中  3:请求成功  4: 请求失败
    yield put({
      type: GAMECDK_CREATE_QRCODE_SUCCESS,
      data: { loading: 1 },
    });

    const axios = yield createAxiosGameCDK();
    let params = {
      chan: 'pcstore',
      price: 9,
      sid: 31065,
      appId: '486931631758625',
      nonce: generateRandomString(10),
      plat: 'pcstore',
      sign_type: 'RSA2',
      sign: '',
      timestamp: +new Date(),
      ...data.param,
    };
    params.sign = getSHA256withRSA(params);

    const res = yield axios.post(GAMECDK_CREATE_QRCODE_9011, { ...params });
    if (res?.data?.code === 10000) {
      yield put({
        type: GAMECDK_CREATE_QRCODE_SUCCESS,
        data: { ...res.data, loading: 3 },
      });
    } else {
      logNative(`游戏CDK 创建订单接口请求失败 ${res}`);
      yield put({
        type: GAMECDK_CREATE_QRCODE_SUCCESS,
        data: { message: '很抱歉，网络异常，请稍后再试', ...res.data, loading: 4 },
      });
    }
  } catch (error) {
    logNative(`游戏CDK 创建订单接口请求失败 ${error}`);
    yield put({
      type: GAMECDK_CREATE_QRCODE_SUCCESS,
      data: { message: '很抱歉，网络异常，请稍后再试', loading: 4, code: 531 },
    });
  }
}

function* fetchGameCdkPolls(data) {
  try {
    const axios = yield createAxiosGameCDK();
    const res = yield axios.get(GAMECDK_POLL_9011, { params: data.param });
    if (res?.data?.code === 10000) {
      yield put({
        type: GAMECDK_POLL_SUCCESS,
        data: { ...res?.data, index: +new Date() },
      });
    }
  } catch (error) {
    throw error;
  }
}
function* fetchGameCdkGetDesc(data) {
  try {
    const axios = yield createAxios();
    const res = yield axios.get(GAMECDK_GET_DESC_9011, { params: {} });
    if (res?.data?.status === 0 && res?.data?.data) {
      yield put({
        type: GAMECDK_CODE_GET_DESC_SUCCESS,
        data: { ...res?.data?.data },
      });
    }
  } catch (error) {
    throw error;
  }
}

export function* watchGameCdkQRcode() {
  yield takeLatest(GAMECDK_CREATE_QRCODE, fetchGameCdkQRcode);
}

export function* watchFetchGameCdkPolls() {
  yield takeLatest(GAMECDK_POLLS, fetchGameCdkPolls);
}

export function* watchFetchGameCdkGetDesc() {
  yield takeLatest(GAMECDK_CODE_GET_DESC, fetchGameCdkGetDesc);
}
